import { useMemo } from "react";
import { LeafIcon } from "./Reveal";

const GREENS = ["#1b6b1f", "#2e8b32", "#4c9a3f", "#0f4a13", "#6fae5a"];

export const Leaves = ({ count = 16, opacity = 1 }) => {
  const leaves = useMemo(
    () =>
      Array.from({ length: count }, (_, i) => {
        const r = (n) => (Math.sin(i * 97.13 + n * 13.7) + 1) / 2;
        return {
          left: `${Math.round(r(1) * 100)}%`,
          size: 14 + Math.round(r(2) * 22),
          dur: `${14 + r(3) * 14}s`,
          delay: `${-r(4) * 26}s`,
          sway: `${3 + r(5) * 3}s`,
          drift: `${Math.round((r(6) - 0.5) * 260)}px`,
          color: GREENS[i % GREENS.length],
          blur: r(7) > 0.8 ? 1.5 : 0,
        };
      }),
    [count]
  );

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" style={{ opacity }} aria-hidden="true" data-testid="falling-leaves">
      {leaves.map((l, i) => (
        <span
          key={i}
          className="leaf"
          style={{ left: l.left, "--dur": l.dur, "--delay": l.delay, "--sway": l.sway, "--drift": l.drift, filter: l.blur ? `blur(${l.blur}px)` : undefined }}
        >
          <LeafIcon fill={l.color} className="block" style={{ width: l.size, height: l.size }} />
        </span>
      ))}
    </div>
  );
};
